﻿( function( doc ) {
	'use strict';

    const NUMTOLOAD = 5;

	class ProgramViewPage {
		constructor() {
			this.progContainer = app.$( '#program-container' );
			this.filterBoxArea = app.$( '#filter-box-area' );
			this.btnLoadMore = app.$( '#btn-load-more' );
			this.btnLaunch = app.$( '#bt-open-filter' );
            this.lastIdx = -1;
            this.prgIdx = [];
            this.curProvider = '';
            this.loadIndex();
            this.bindFilterEvents();
            this.topOfFilterBox = this.filterBoxArea.getBoundingClientRect().top;
            this.bindLaunch();
		}

        bindFilterEvents() {
        	const btnClear = app.$( '#btn-clear-filter' );
        	const btnApply = app.$( '#btn-apply-filter' );
        	const btnfilterClose = app.$( '#btn-box-close' );

        	if ( btnfilterClose ) {
        		btnfilterClose.addEventListener( 'click', e => {
        			doc.body.classList.remove( 'nav-in' );
        			doc.body.classList.toggle( 'filter-in' );
        		} );
        	}

        	doc.addEventListener( 'scroll', e => {
        		const y = app.util.getWindowScrollPosition();

                //let newTopMargin = y - this.topOfFilterBox;

                //if ( newTopMargin < 0 ) {
                //    newTopMargin = 0;
                //}

                //if ( newTopMargin > 40 && this.progContainer.offsetHeight > this.filterBoxArea.offsetHeight ) {
                //    this.filterBoxArea.classList.add( 'fixed' );
                //} else {
                //    this.filterBoxArea.classList.remove( 'fixed' );
                //}

            	// Auto load more content on scroll
                if ( this.lastProgramItem && !this.loadingPrograms ) {

                	if ( y + window.innerHeight >= this.lastProgramItem.offsetTop ) {
                		this.loadList(false);
                	}
                }

            } );

            if ( this.btnLoadMore ) {
                this.btnLoadMore.addEventListener( 'click', e => {
                    this.loadList(false);
                });
            }

            if ( btnClear ) {
                btnClear.addEventListener( 'click', e => {
                    app.$.fetch( 'api/programEventFitlerBoxGet', {}).then( rsp => {

                    	if ( rsp.success ) {
                            this.filterBoxArea.innerHTML = rsp.obj;
                            this.bindFilterEvents();
                            this.loadIndex();
                        } else {
                            console.log( rsp.msg );
                        }

                        window.scrollTo( 0, 0 );
                    } );
                });
            }

            if ( btnApply ) {

                btnApply.addEventListener( 'click', e => {
                    //collect filter settings
                    const ddProvider = app.$( '#dd-provider' ),
                          gradeArea = app.$( '#grade-filter' ),
                          contentArea = app.$( '#content-filter' );

                    let grades = '',
                        contents = '';

                    app.$$('input[type="checkbox"]:checked', gradeArea).forEach(el => {
                        grades +=  el.value + ',';
                    });

                    app.$$('input[type="checkbox"]:checked', contentArea).forEach(el => {
                        contents +=  el.value + ',';
                    });

                    const filter = {
                        providerId: ddProvider.value,
                        grades: grades,
                        contents: contents
                    };

                    this.loadIndex( filter );

                    doc.body.classList.remove( 'filter-in' );

                    window.scrollTo( 0, 0 );
                } );
            }
        }

        loadList( cleanContainer ) {

            //First we need to build a list of the next needed events
            if ( this.lastIdx < this.prgIdx.length ) {
				
                let cntr = 1,
                    neededPrgs = [],
                    insertMonthBefore = [];

                //Build list of needed events to pass to web service
                while ( this.lastIdx < this.prgIdx.length - 1 ) {
                	this.lastIdx += 1;

                    neededPrgs.push( this.prgIdx[this.lastIdx].programId );

                    if ( this.prgIdx[this.lastIdx].provider !== this.curProvider ) {
                        insertMonthBefore.push( this.prgIdx[this.lastIdx].programId );
                        this.curProvider = this.prgIdx[this.lastIdx].provider;
                    }
                    cntr += 1;
                    if ( cntr > NUMTOLOAD ) {
                        break;
                    }
                }

                if ( neededPrgs.length > 0 ) {
                	this.loadingPrograms = true;

                    app.$.fetch( 'api/programsGetForView', {
                        body: {
                            programs: neededPrgs
                        }
                    }).then( rsp => {

                        if ( rsp.success ) {
                        	
                        	const displayPrgs = rsp.obj;

                            if ( cleanContainer ) {
                               this.progContainer.innerHTML = '';
                            }

                            for ( let i = 0; i < displayPrgs.length; i++ ) {
                                let prg = displayPrgs[i];
						
                                //Check to see if we need to insert the Month before current event
                                let idxBefore = insertMonthBefore.indexOf( prg.programId );
                                if ( idxBefore > -1 ) {
                                    // need to insert month header, find the event in the EventList to get month display string.
                                    for ( let cnt = 0; cnt < this.prgIdx.length; cnt++ ) {
                                        let e = this.prgIdx[cnt];
                                    	if ( e.programId === insertMonthBefore[idxBefore] ) {
                                    		let providerDisplay = doc.createElement( 'div' );
                                    		providerDisplay.textContent = e.provider;
                                    		providerDisplay.classList.add( 'program-view-provider-head' );
                                            this.progContainer.appendChild( providerDisplay );
                                        }
                                    }
                                }

                                //dislay the program on page
                                let onePrgContainer = doc.createElement( 'div' );
                                onePrgContainer.innerHTML = prg.html;
                                this.progContainer.appendChild( onePrgContainer );
                                let a = new app.ProgramItem(prg.programId, onePrgContainer);

                                if ( i + 1 === displayPrgs.length ) {

                                    /* jshint loopfunc: true */
                                    requestAnimationFrame( _ => this.lastProgramItem = onePrgContainer);

                                	// Display FREE when they enter 0 as Cost
                                  //  const costValue = app.$$( '.cost-val' );

                                  //  costValue.forEach( el => {
                                		//if (el.innerHTML === '$0' || el.innerHTML === '0') {
                                		//	el.innerHTML = 'FREE';
                                		//}
                                  //  } );
                                }
                            } // end of program list loop

                            const cbFree = app.$( '#cb-free' );
                            const progItems = app.$$( '.program-item-container' );

                            if ( cbFree.checked ) {
                                progItems.forEach( prog => {
                                    const cost = app.$( '.cost-val', prog );
                                    const prevMonthHdr = prog.previousSibling;
                                    const nextMonthHdr = prog.nextSibling;

                                    if ( cost.textContent === '$FREE' || cost.textContent === 'FREE' ) {
                                        prog.classList.add( 'free' );
                                    } else {
                                        prog.classList.add( 'not-free' );
                                    }

                                } );
                            }

                        } else {
                            console.log( rsp.msg );
                        }

                        this.loadingPrograms = false;

                    });
                }

                if ( neededPrgs.length < NUMTOLOAD ) {
                    this.btnLoadMore.classList.add( 'hidden' );
                }

            } else {
                this.btnLoadMore.classList.add( 'hidden' );
            }
        }


        loadIndex( filter ) {

            if ( !filter ) {
                filter = {
                    providerId: -1,
                    grades: '',
                    contents: ''
                };
            }

            this.btnLoadMore.classList.add( 'hidden' );
            this.progContainer.innerHTML = '<div class="hollow-dots-spinner" :style="spinnerStyle"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>';
            this.curProvider = '';

            app.$.fetch( 'api/programsGetFiltered', {
				body: {
                    filter: JSON.stringify(filter)
				}
			} ).then( rsp => {
				if ( rsp.success ) {
                    this.prgIdx = rsp.obj;
                    this.lastIdx = -1;
                    this.progContainer.innerHTML = '';
                    this.btnLoadMore.classList.remove( 'hidden' );
                    this.loadList( true );
				} else {
					console.log( rsp.msg );
				}
			} );
        }

        bindLaunch() {
        	if ( this.btnLaunch ) {
        		this.btnLaunch.addEventListener( 'click', e => {
        			doc.body.classList.toggle( 'filter-in' );
        		} );
        	}
        }
	}

	let pvp = new ProgramViewPage();

} )( document );